import { fetchCookieCountFromApi, fetchCountFromApi } from "@modules/bookmarks/entries/entries-api.ts"
import { Cookie } from "@modules/util/Cookie.ts"

export async function appendMerkzettelForDevice(isMobile: boolean, data: any) {
    if (isMobile) {
        appendMerkzettelForMobile(data)
    } else {
        appendMerkzettelForPc(data)
    }
}

export async function appendMerkzettelForPc(data: any) {
    const anchor = document.querySelector(".merkz-btn-menu")
    if (!anchor) {
        return
    }

    anchor.classList.add("has-items")

    const counter = anchor.querySelector(".merkzettel-counter")
    if (data.count && counter) {
        counter.textContent = data.count.toString()
    }

    const dropdown = document.createElement("div")
    dropdown.id = data.ddData.ddId
    dropdown.className = "drop-container merkzettel-dropdown"

    const listItems = data.ddData.ddList
        .map(
            (item: any, index: number) => `
        <li class="dropdown-list-item" data-aid="${item.id}">
          <a href="${item.link}" target="${item.target}" class="link" title="">
            <span class="thumbnail">
              <img src="${item.thumbnail.url}" alt="${item.thumbnail.alt}" class="img-responsive" data-image-id="img-${index + 1}">
            </span>
            <span class="text">
              <span class="text-bold display-block">${item.name}</span>
              ${item.ort}
            </span>
          </a>
        </li>`,
        )
        .join("")

    dropdown.innerHTML = `
      <div class="dropdown-arrow">
        <div class="arrow"></div>
      </div>
      <div class="dropdown-base">
        <div class="dropdown-content">
          <h2 class="dropdown-header info-heading">${data.ddData.ddTitle}</h2>
          <ul class="dropdown-list">
            ${listItems}
          </ul>
          <div class="dropdown-footer">
            <span class="ddlFooter">${data.ddData.ddFooterText}</span>
            <a class="blue-link" href="${data.ddData.ddLink.url}">${data.ddData.ddLink.label}</a>
          </div>
        </div>
      </div>`

    const menuBtnLi = anchor.closest(".menu-btn")
    if (!menuBtnLi) {
        return
    }

    menuBtnLi.appendChild(dropdown)
}

export async function appendMerkzettelForMobile(data: any) {
    const count = data?.ddData?.ddCount?.total ?? 0
    const btn = document.querySelector(".merkz-btn-menu")
    const counterEl = btn?.querySelector(".merkzettel-counter")

    if (counterEl) {
        counterEl.textContent = count
    }

    if (btn) {
        if (count > 0) {
            btn.classList.add("has-items")
        } else {
            btn.classList.remove("has-items")
        }
    }
}

export async function updateMerkzettelStateInMenuForDevice(isMobile: boolean, count: number) {
    const bookmarkEntriesCountCookie = new Cookie("bookmarkEntriesCount", {
        path: "/",
        domain: SiteInfo.cookieDomain,
    })

    bookmarkEntriesCountCookie.value = { count: count }
    bookmarkEntriesCountCookie.expires = Cookie.getExpireDate(300)

    if (isMobile) {
        appendMerkzettelStateInMenuForMobile(count)
    } else {
        appendMerkzettelStateInMenuForPc(count)
    }
}

export async function appendMerkzettelStateInMenuForPc(count: number) {
    const anchor = document.querySelector(".merkz-btn-menu")
    if (!anchor) {
        return
    }

    if (count > 0) {
        anchor.classList.add("has-items")
    } else {
        anchor.classList.remove("has-items")
    }

    const counter = anchor.querySelector(".merkzettel-counter")
    if (count && counter) {
        counter.textContent = count.toString()
    }
}

export async function appendMerkzettelStateInMenuForMobile(count: number) {
    const btn = document.querySelector(".merkz-btn-menu")
    const counterEl = btn?.querySelector(".merkzettel-counter")

    if (counterEl) {
        counterEl.textContent = count.toString()
    }

    if (btn) {
        if (count > 0) {
            btn.classList.add("has-items")
        } else {
            btn.classList.remove("has-items")
        }
    }
}

export const updateMerkzettelStateInMenu = async (resetCookie = false): Promise<void> => {
    // OLD bookmarks
    if (!SiteInfo.bookmarksPageActive) {
        // Checken ob cookie schon gesetzt worden ist
        const fetchMerkzettelCookieExists = document.cookie
            .split("; ")
            .some((cookie) => cookie.startsWith("CCMerkzettelFetched"))
        let cookieData = null

        if (userData.isLoggedIn && !fetchMerkzettelCookieExists) {
            fetchMerkzettel(SiteInfo.isMobileDevice)
        } else if (userData.isLoggedIn && fetchMerkzettelCookieExists) {
            cookieData = localStorage.getItem("CCMerkzettelData")
        }

        if (userData.isLoggedIn && cookieData !== null) {
            const parsedData = JSON.parse(cookieData)
            const merkzettelAdvertList = siteConfig.merkzettelIds

            if (merkzettelAdvertList.length !== parsedData.count) {
                fetchMerkzettel(SiteInfo.isMobileDevice)
            } else {
                appendMerkzettelForDevice(SiteInfo.isMobileDevice, parsedData)
            }
        }
    } else {
        let bookmarkEntriesCount = 0
        if (userData.isLoggedIn) {
            const bookmarkEntriesCountCookie = new Cookie("bookmarkEntriesCount", {
                path: "/",
                domain: SiteInfo.cookieDomain,
            })

            if (resetCookie) {
                bookmarkEntriesCountCookie.value = {}
            }

            if (bookmarkEntriesCountCookie.value?.count !== undefined) {
                bookmarkEntriesCount = Number.parseInt(bookmarkEntriesCountCookie.value.count)
            } else {
                await fetchCountFromApi(userData.userId)
                    .then((entriesCount) => {
                        bookmarkEntriesCount = entriesCount
                    })
                    .catch(() => {
                        bookmarkEntriesCount = 0
                    })
                bookmarkEntriesCountCookie.value = { count: bookmarkEntriesCount }
                bookmarkEntriesCountCookie.expires = Cookie.getExpireDate(300)
            }

            updateMerkzettelStateInMenuForDevice(SiteInfo.isMobileDevice, bookmarkEntriesCount)
        } else {
            const cookieBookmarkEntriesCountCookie = new Cookie("cookieBookmarkEntriesCount", {
                path: "/",
                domain: SiteInfo.cookieDomain,
            })

            if (resetCookie) {
                cookieBookmarkEntriesCountCookie.value = {}
            }

            if (cookieBookmarkEntriesCountCookie.value?.count !== undefined) {
                bookmarkEntriesCount = Number.parseInt(cookieBookmarkEntriesCountCookie.value.count)
            } else {
                await fetchCookieCountFromApi()
                    .then((entriesCount) => {
                        bookmarkEntriesCount = entriesCount
                    })
                    .catch(() => {
                        bookmarkEntriesCount = 0
                    })
                cookieBookmarkEntriesCountCookie.value = { count: bookmarkEntriesCount }
                cookieBookmarkEntriesCountCookie.expires = Cookie.getExpireDate(3600 * 24 * 30)
            }

            updateMerkzettelStateInMenuForDevice(SiteInfo.isMobileDevice, bookmarkEntriesCount)
        }
    }
}

export async function fetchMerkzettel(isMobile: boolean) {
    const apiBaseUrl = SiteInfo.yiiLadiesUrl
    const apiEndpoint = `${apiBaseUrl}/merkzettel/AjaxUpdate`
    await fetch(apiEndpoint, {
        method: "POST",
        credentials: "include",
        body: new URLSearchParams({
            Action: "loginOverCC",
        }),
    })
        .then((response) => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
            return response.json()
        })
        .then((data) => {
            if (data["count"] === 0) {
                return
            }

            const cookieData = JSON.stringify(data)
            localStorage.setItem("CCMerkzettelData", cookieData)

            if (!isMobile) {
                appendMerkzettelForPc(data)
                return
            }

            appendMerkzettelForMobile(data)
        })
}
